export default __webpack_public_path__ + "static/media/twitter.b80161ac.svg";